import { useScroll } from "motion/react";
import { useRef } from "react";
import { Word } from "./Word";
import { twMerge } from "tailwind-merge";

type EdgeOffset = [
  (
    | "start"
    | "center"
    | "end"
    | `start ${number}`
    | `center ${number}`
    | `end ${number}`
  ),
  (
    | "start"
    | "center"
    | "end"
    | `start ${number}`
    | `center ${number}`
    | `end ${number}`
  ),
];
interface SubheadingProps {
  placeholder: string;
  size?: "sm" | "md" | "lg";
  fontIndex?: number[];
  justify?: "start" | "end";
  className?: string;
  speed?: EdgeOffset;
}

export const Subheading = ({
  placeholder,
  size = "sm",
  fontIndex,
  justify = "start",
  className,
  speed = ["start 0.75" as const, "start 0.25" as const],
}: SubheadingProps) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: speed,
  });

  const words = placeholder.split(" ");
  return (
    <div ref={containerRef} className="relative">
      <p
        className={twMerge(
          className,
          ` ${justify === "start" ? "justify-start" : "justify-end"} ${
            // ` ${justify === "start" ? "justify-start" : "justify-end"} ${
            size === "sm"
              ? "leading-8 sm:leading-10"
              : size === "md"
                ? "leading-9 sm:leading-10 lg:leading-12"
                : "leading-10 sm:leading-16 lg:leading-22"
          } flex flex-wrap text-white relative`,
        )}
        // className={` ${justify === "start" ? 'justify-start' : 'justify-end' } ${size === "sm" ? "leading-10 w-[337px]" : size === "md" ? "leading-12 w-[560px]" : "leading-22 w-[544px] "} flex flex-wrap text-white  text-lg relative `}
      >
        {words.map((word, index) => {
          const start = index / words.length;
          const end = start + 1 / words.length;
          const isHighlighted = fontIndex && fontIndex.includes(index);
          return (
            <Word
              key={index}
              word={word}
              range={[start, end]}
              progress={scrollYProgress}
              size={size}
              isHighlighted={isHighlighted}
            />
          );
        })}
      </p>
    </div>
  );
};
